<template>
  <b-modal
    id="typeFlyerModal" 
    ref="typeFlyerModal" 
    no-close-on-backdrop
    centered
    v-model="showModal" 
    :title="isUpdate ? 'Atualizar panfleto' : 'Adicionar panfleto'" 
    hide-footer
    size="xl"
  >
    <b-row>
      <b-col align="center" cols="6">
        <b-row>
          <b-col cols="12">
            <div v-if="fields.image">
              <img
                :src="getImageAddress(fields.image)"
                alt="Imagem do panfleto"
                style="width: 60%; height: auto;"
              />
            </div>
            <div v-else>
             <i class="fas fa-image" style="font-size: 250px;"></i>
            </div>
            <div v-if="fields.image">
              <b-form-checkbox 
                v-model="fields.is_cover"
                switch 
                class="mt-2"
              >Deseja tornar esse panfleto a capa do tipo?</b-form-checkbox>
            </div>
          </b-col>
          <b-col cols="12" class="mt-3">
            <b-button 
              v-if="fields.image"
              variant="danger" 
              :disabled="loading"
              @click="removeImage()"
              block
            >
              <i class="fas fa-trash-alt mr-2"></i>
              Excluir Panfleto
            </b-button>
            <div v-else class="form-group">
              <div class="custom-file m-t-20">
                <input
                  type="file"
                  id="file"
                  ref="file"
                  class="custom-file-input"
                  lang="pt"
                  @change="uploadImage()"
                  accept="image/x-png, image/gif, image/jpeg"
                />
                <label
                  class="custom-file-label"
                  for="file"
                >
                  Insira uma imagem com no máximo 2480 x 3508 pixels!
                </label>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="6" class="mt-4">
        <b-form>
          <b-form-group label="Tipo:">
            <b-form-select 
              v-model="selected" 
              :options="options"
              placeholder="Selecione um tipo" 
            />
          </b-form-group>

          <b-form-group label="Nome (opcional):" class="mt-3">
             <b-form-input 
                v-model="fields.name"
                placeholder="Ex: Material básico"
             />
          </b-form-group>
        </b-form>
        <span class="mt-4"><strong>Obs: </strong> 
          Para salvar a imagem é necessário clicar em salvar/atualizar após fazer o upload
        </span>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col cols="12" md="6">
        <b-button @click="closeModal()" variant="outline-danger" block :disabled="loading">Cancelar</b-button>
      </b-col>
      <b-col cols="12" md="6">
        <b-button v-if="!isUpdate" @click="save()" variant="success" block :disabled="loading">Salvar</b-button>
        <b-button v-else @click="update()" variant="success" block :disabled="loading">Atualizar</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';
export default {
  name: 'FlyerModal',
  mixins: [makeToast],
  emits: ['flyerSave', 'flayerUpdate'],

  data() {
    return {
      loading: false,
      showModal: false,
      isUpdate: false,
      selected: null,
      options: [
        { value: null, text: 'Selecione uma opção' },
      ],
      fields: {
        id: null,
        type_flyers_id: null,
        name: "",
        link: "",
        image: null,
        is_cover: false,
      },  
    };
  },
    computed: {
    ...mapState(['dadosUsuario']),
  },
  methods: {
    ...mapActions('shopkeeper', [
      'uploadImageFlyer',
      'deleteImageFlyer',
    ]),

    toggleOpen({ data = null, options = [], isUpdate = false }) {
      this.clean();
      this.getTypes(options);
      this.isUpdate = isUpdate;
      this.showModal = !this.showModal;
      
      if(data) {
        this.fields.name = data.title;
        this.fields.link = data.link;
        this.fields.image = data.image;
        this.fields.id = data.id;
        this.fields.is_cover = data.isCover === 1 ? true : false;
        this.fields.type_flyers_id = data.typeId;
        this.selected = data.typeId;
      }
    },
    save() {
      this.fields.type_flyers_id = this.selected;

      if(this.validation() === false) return;

      this.$emit('flyerSave', this.fields);
      this.closeModal();
    },
    update() {
      this.fields.type_flyers_id = this.selected;

      if(this.validation() === false) return;

      this.$emit('flayerUpdate', this.fields);
      this.closeModal();
    },
    closeModal() {
      this.showModal = !this.showModal;
    },
    validation() {
      if(!this.fields.type_flyers_id) {
        this.$bvToast.toast('O tipo do panfleto não pode ser vazio', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
        return false;
      }

      return true;
    },
    clean () {
      this.fields.name = "";
      this.fields.link = "";
      this.fields.image = null;
      this.fields.id = null;
      this.fields.is_cover = false;
      this.fields.type_flyers_id = null;
      this.selected = null;
      this.options = [
        { value: null, text: 'Selecione uma opção' },
      ];
      this.isUpdate = false;
    },
    getImageAddress(image) {
      const url = process.env.VUE_APP_FOTOS_AWS + 'panfletos/'; 
      return url + image;
    },
    getTypes(items) {
      items.forEach(element => {
        this.options.push({
          value: element.id,
          text: element.name,
        });
      });
    },
    uploadImage() {
      const formData = new FormData();
      this.fields.image = this.$refs.file.files[0];
      formData.append('file', this.fields.image);

      this.$store.dispatch('startLoader');
      this.loading = true;

      this.uploadImageFlyer(formData)
        .then((response) => {
          const name = response.data.data;

          if (!name) return;
          this.fields.image = name;

        })
        .catch((error) => {
           this.$store.dispatch('endLoader');
          this.makeToast('Oopss!', 'Houve um erro ao salvar', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    removeImage() {
      const data = {
        id: this.fields.id,
        image: this.fields.image,
      }

      this.deleteImageFlyer(data)
        .then((response) => {
          const data = response.data.data;

          if (!data) return;
          this.fields.image = null;
          this.makeToast('Sucesso!', 'Removido com sucesso', 'success');

        })
        .catch((error) => {
          this.$store.dispatch('endLoader');
          this.makeToast('Oopss!', 'Houve um erro ao salvar', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
  },
};
</script>
